import { franc } from 'franc-min';

const FJStringUtil = {
    isEnglish: function (str) {
        return this.getStringLanguage(str) === 'eng';
    },
    /**
     * @description 获取文件名
     * @param path
     * @param deleteExt
     * @returns {string}
     */
    getFileName: function (path, deleteExt) {
        if (!path) return '';
        let name = path.substr(path.lastIndexOf('/') + 1);
        if (deleteExt) name = name.split('.')[0];
        return name;
    },
    getStringLanguage: function (str) {
        return franc(str);
    },

    getFileSuffix: function (name) {
        return name.split('.').pop();
    },

    getUseFileName: function (name, suffix) {
        const now = new Date();
        // 获取年、月、日、时、分、秒
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1并补零
        const day = String(now.getDate()).padStart(2, '0'); // 补零
        const hours = String(now.getHours()).padStart(2, '0'); // 补零
        const minutes = String(now.getMinutes()).padStart(2, '0'); // 补零
        const seconds = String(now.getSeconds()).padStart(2, '0'); // 补零

        // 格式化日期和时间为 2024-07-17T111525
        return `${name}-Made with FlexClip AI-${year}-${month}-${day}T${hours}${minutes}${seconds}${suffix}`;
    },

    getByteLen: function (str) {
        // return encodeURIComponent(str).replace(/%[A-F\d]{2}/g, 'U').length;
        let len = 0;
        for (let i = 0; i < str.length; i++) {
            str.charCodeAt(i) < 256 ? (len += 1) : (len += 2);
        }
        return len;
    },

    sliceByteLen: function (str, num) {
        if (!str || num <= 0) return '';

        let result = '';
        let asciiCount = 0;

        // 使用扩展运算符将字符串分解为字符数组
        for (const char of [...str]) {
            // 获取字符的 ASCII 值长度
            const charCode = char.charCodeAt(0);
            // ASCII 字符（0-127）计数为1，其他字符计数为2
            const charLength = charCode < 256 ? 1 : 2;

            // 检查是否超出限制
            if (asciiCount + charLength > num) {
                break;
            }

            result += char;
            asciiCount += charLength;
        }

        return result;
    },
};
export default FJStringUtil;
